export default __webpack_public_path__ + "static/media/extension-edge.0b08bccd.svg";